<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<h1 class="booktitle"><strong>Cooking with Joy</strong><br/><br/><br/></h1>
<p class="center"><strong><span class="border">THE 90/10 COOKBOOK</span></strong></p>
<p class="center"><br/><br/><br/><br/></p>
<p class="center">                    <span class="big2">Joy Bauer, M.S., R.D., C.D.N.,</span></p>
<p class="center1">with Rosemary Black     <br/><br/><br/><br/><br/><br/></p>
<p class="center">       St. Martin’s Press  <img alt="" class="middle" src="OEBPS/images/9781429983969_L01.png"/>  New York</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781429983969_epub_tp_r1.vue?add947e6